"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _en_US = _interopRequireDefault(require("rc-pagination/lib/locale/en_US"));
var _en_US2 = _interopRequireDefault(require("../DatePicker/locale/en_US"));
var _en_US3 = _interopRequireDefault(require("../Calendar/locale/en_US"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // import DatePicker from '../date-picker/locale/en_US';
// import TimePicker from '../time-picker/locale/en_US';
var _default = exports.default = {
  locale: 'en',
  // Pagination,
  DatePicker: _en_US2.default,
  // TimePicker,
  Calendar: _en_US3.default,
  Pagination: _objectSpread(_objectSpread({}, _en_US.default), {}, {
    totalText: 'Total {total} record'
  }),
  Table: {
    filterTitle: 'Filter menu',
    filterConfirm: 'OK',
    filterReset: 'Reset',
    emptyText: 'No data',
    selectAll: 'Select current page',
    selectInvert: 'Invert current page',
    totalText: 'Total {total} records',
    edit: 'Edit',
    detail: 'Details',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    sortCancel: 'Click to cancel sort',
    sortAsc: 'Click to sort by ascend',
    sortDesc: 'Click to sort by descend',
    undo: 'Undo',
    selectionInfo: '{count} of {total} record selected.'
  },
  TableHeader: {
    add: 'Add',
    refresh: 'Refresh',
    excelExport: 'Excel Export',
    csvExport: 'Csv Export'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Cancel',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Cancel'
  },
  Select: {
    notFoundContent: 'Not Found',
    placeholder: 'Select',
    copy: 'Copy'
  },
  TreeSelect: {
    notFoundContent: 'Not Found',
    placeholder: 'Select'
  },
  Spin: {
    loadingText: 'Loading...'
  },
  Upload: {
    uploading: 'Uploading...',
    removeFile: 'Remove file',
    uploadError: 'Upload error',
    previewFile: 'Preview file',
    dragText: 'Drop files to attach, or',
    dragLinkText: 'browse.'
  },
  Text: {
    edit: 'Edit',
    copy: 'Copy',
    copied: 'Copied',
    expand: 'Expand'
  },
  NumberInput: {
    numericValidationError: 'Numeric values is allowed.'
  }
};